// extracted by mini-css-extract-plugin
export default {"content":"BeneficiariesDocuments_content__WvS5o"};